import { importOrganisationRoles, previewOrganisationRoleImport } from '@infuse/api/iam/organisation';
import { importRoles, previewRoleImport } from '@infuse/api/iam/role';
import { importTenantRoles, previewTenantRoleImport } from '@infuse/api/iam/tenant';
import { useCurrentUserStore } from '@infuse/iam/user/store';
import { UserLevel } from '@infuse/iam/user/type';
import { useGenericImportRoles, useGenericPreviewRoleImport } from './generic/useGenericImportRoles';

export const usePreviewRoleImport = (forcedLevel?: UserLevel, forcedParentId?: string) => {
  const { level, user } = useCurrentUserStore();

  if ((forcedLevel || level) === UserLevel.TENANT) {
    return useGenericPreviewRoleImport({
      apiFn: previewTenantRoleImport,
      forcedParentId: forcedParentId || user?.tenantId
    });
  } else if ((forcedLevel || level) === UserLevel.ORGANISATION) {
    return useGenericPreviewRoleImport({
      apiFn: previewOrganisationRoleImport,
      forcedParentId: forcedParentId || user?.organisationId
    });
  }

  return useGenericPreviewRoleImport({ apiFn: previewRoleImport });
};

export const useImportRoles = (forcedLevel?: UserLevel, forcedParentId?: string) => {
  const { level, user } = useCurrentUserStore();

  if ((forcedLevel || level) === UserLevel.TENANT) {
    return useGenericImportRoles({
      apiFn: importTenantRoles,
      forcedParentId: forcedParentId || user?.tenantId
    });
  } else if ((forcedLevel || level) === UserLevel.ORGANISATION) {
    return useGenericImportRoles({
      apiFn: importOrganisationRoles,
      forcedParentId: forcedParentId || user?.organisationId
    });
  }

  return useGenericImportRoles({ apiFn: importRoles });
};
